import { StrictMode, createRoot } from "@wordpress/element";
import FaqSearchForm from "./FaqSearchForm";

// Mount the component to the 'root' div
const root = document.getElementById('content-faqs-search');
if (root) {
  createRoot(root).render(
    <StrictMode>
      <FaqSearchForm />
    </StrictMode>
  );
}
